const updateCurrentDoctor = (doctor) => ({
  type: 'UPDATE_CURRENT_DOCTOR',
  doctor,
});

export default updateCurrentDoctor;
